import React from 'react';
import {
  DashboardMenuItem,
  usePermissions
} from 'react-admin';
import Divider from '@mui/material/Divider';
import { MultiLevelMenu, MenuItemNode } from "@react-admin/ra-navigation";

// Icone Material UI consigliate
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import QuizIcon from '@mui/icons-material/Quiz';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EventIcon from '@mui/icons-material/Event';
import StarIcon from '@mui/icons-material/Star';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import SportsIcon from '@mui/icons-material/Sports';
import PersonIcon from '@mui/icons-material/Person';
import CategoryIcon from '@mui/icons-material/Category';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import GroupsIcon from '@mui/icons-material/Groups';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PaymentIcon from '@mui/icons-material/Payment';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';

import { iconStyle } from '../Styles/iconsStyles';
import { cssMultiLevelMenu } from '../Styles/menuStyles';

export const MyMenu = (props) => {
  const { permissions } = usePermissions();

  return (
    <MultiLevelMenu sx={cssMultiLevelMenu}>
      {permissions === 'admin' &&
        <>
          {/* Dashboard */}
          <DashboardMenuItem to="/" leftIcon={<DashboardIcon style={iconStyle} />} />

          {/* Sezione Gestione Sportiva */}
          <MenuItemNode name="squadre" to="/squadre" label="Squadre" icon={<>⚽</>} />
          <MenuItemNode name="giocatori" to="/giocatori" label="Giocatori" icon={<>👨‍💼</>} />
          <MenuItemNode name="partite" to="/partite" label="Partite" icon={<>📅</>} />
          <MenuItemNode name="giornate" to="/giornate-calendario" label="Giornate" icon={<>📆</>} />
          <MenuItemNode name="leghe" to="/leghe" label="Leghe" icon={<>🏆</>} />
          <MenuItemNode name="classifica" to="/classifica" label="Classifica" icon={<>📊</>} />
          <MenuItemNode name="tools-giornate" to="/tools-giornate" label="Tools Giornate" icon={<>🛠️</>} />

          <Divider />

          {/* Sezione Amministrazione */}
          <MenuItemNode name="users" to="/users" label="Gestione Users" icon={<>🧑‍🤝‍🧑</>} />
          <MenuItemNode name="gruppi" to="/gruppi" label="Gruppi" icon={<>👥</>} />
          <MenuItemNode name="piani" to="/piani" label="Piani" icon={<>📦</>} />
          {/* <MenuItemNode name="users-view" to="/users-view" label="Vista Avanzata Utenti" icon={<>👥</>} /> */}
          {/*   <MenuItemNode name="tbl_user_team" to="/tbl-user-team" label="Utenti e Squadre" icon={<>🤝</>} />
          */} <MenuItemNode name="stripe-transactions" to="/tbl-transactions" label="Transazioni Stripe" icon={<>💳</>} />
          <MenuItemNode name="system-health" to="/system-health" label="System Health" icon={<>🩺</>} />
          <MenuItemNode name="richieste-cancellazione" to="/richieste-cancellazione" label="Richieste Cancellazione" icon={<>🗑️</>} />

          <Divider />

          {/* Sezione Configurazione */}
          {/* <MenuItemNode name="tbl_stagione" to="/tbl-stagione" label="Stagioni" icon={<EventIcon style={iconStyle} />} />
          <MenuItemNode name="tbl_lega_stagione" to="/tbl-lega-stagione" label="Stagioni Lega" icon={<EventIcon style={iconStyle} />} />
          <MenuItemNode name="tbl_mvpmese" to="/tbl-mvpmese" label="MVP del Mese" icon={<LeaderboardIcon style={iconStyle} />} />
          <MenuItemNode name="tbl_ruolo" to="/tbl-ruolo" label="Ruoli" icon={<CategoryIcon style={iconStyle} />} />
          <MenuItemNode name="tbl_sostituzione" to="/tbl-sostituzione" label="Sostituzioni" icon={<SwapHorizIcon style={iconStyle} />} /> */}
        </>
      }

      {permissions === 'collaboratore' &&
        <>
          <MenuItemNode name="dashboard" to="/" label="Dashboard" icon={<DashboardIcon style={iconStyle} />} />
        </>
      }
    </MultiLevelMenu>
  );
};
